import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f44c0ba8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "technologies-section",
  id: "technologies-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Technologies", -1))
const _hoisted_3 = { class: "displayer" }
const _hoisted_4 = { class: "language-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import j_languages from '@/json/languages.json';
import Language from '@/types/Language.type';


export default /*#__PURE__*/_defineComponent({
  __name: 'TechnologiesSection',
  setup(__props) {

const languages: Language[] = j_languages.languages;

return (_ctx: any,_cache: any) => {
  const _component_fai = _resolveComponent("fai")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (l, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "language",
          key: idx,
          style: _normalizeStyle({ color: l.color })
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(l.name), 1),
          _hoisted_5,
          _createVNode(_component_fai, {
            class: "icon",
            icon: 'fa-brands ' + l.icon
          }, null, 8, ["icon"])
        ], 4))
      }), 128))
    ])
  ]))
}
}

})